<template>
    <d-input-group class="calendar-form">
        <datepicker input-class="form-control picker" ref="calendarEnd" v-model="dateRange.from" :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }" placeholder="Start Date" typeable small />
        <div>
            <d-input-group v-on-clickout="hideCalendar">
                <datepicker calendar-class="vdp-datepicker__small" input-class="form-control picker" ref="calendarStart" v-model="dateRange.to" :highlighted="{ from: dateRange.from, to: dateRange.to || new Date() }" placeholder="End Date" typeable small />
                <div class="input-group-text d-none d-sm-block" type="button" @click="showCalendar()" slot="append">
                    <i class="material-icons">&#xE916;</i>
                </div>
            </d-input-group>
        </div>
    </d-input-group>
</template>

<script>
    import { mixin as clickout } from 'vue-clickout';

    export default {
        props: ['dateRange'],

        mixins: [clickout],

        data() {
            return {
                isActive: false
            }
        },

        methods: {
            hideCalendar() {
                this.$refs.calendarStart.close()
            },

            showCalendar() {
                this.isActive = !this.isActive
                if (this.isActive) {
                    this.$refs.calendarEnd.showCalendar()
                    this.$refs.calendarStart.close()
                } else {
                    this.$refs.calendarStart.showCalendar()
                    this.$refs.calendarEnd.close()
                }
            }
        }
    }
</script>